export const PoorROIHint = (
  <>
    Poor ROI - author&apos;s best performing title sold fewer than
    <br />
    200 units in the first 6 months after on-sale.
  </>
);

export const SeriesHasAudioHint = 'A title in this series has audio';

export const LateBloomerHint = 'Late Bloomer';

export const BoxedSetHint = 'This title is a boxed set';